<template>
    <button class="app__btn" @click="$emit('changeModal',true)">
        <img src="../assets/img/add.svg" alt="">
    </button>
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
    
</style>